<template>
  <div>
    <el-card v-loading="loading" style="height: 254px">
      <div slot="header" class="clearfix">
        <b class="font-16">快捷导航 &nbsp;</b>
        <el-link class="float-right" @click="handleEdit">编辑</el-link>

      </div>
      <el-row>
        <el-col @click.native='goToPage(item.url,item)' :span="4" v-for="(item, k) in hasPermissions" :key="k"
                class="colClass">
          <svg-icon class="svgCol" :style="{ color: setColor(k) }" :icon-class="item['icon']"></svg-icon>
          <span>{{ item.display_name }}</span>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title='编辑展示的快捷导航' width='680px' :visible.sync="dialogVisible" center>
      <el-row :gutter='20' style="max-height: 520px;overflow-y: scroll;padding: 0 10px ">
        <el-col @click.native="handleSelect(item)" class="colClass" :span="4" v-for="(item,i) in allHasPermissions"
                :key="i">
          <el-badge class="badge" v-show="isIncloud(item)" is-dot>
          </el-badge>
          <svg-icon class="svgCol" :icon-class="item['icon']"></svg-icon>

          <span>{{ item.display_name }}</span>

        </el-col>

      </el-row>
      <span slot='footer' class='dialog-footer'>
        <el-button size='small' @click='dialogVisible=false'>取消</el-button>
        <el-button size='small' type='primary' @click='handleStore'>保存({{ selectData.length }})</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import menuApi from '@/api/menu_setting'

export default {
  name: 'UserComponentsMyMenus',
  computed: {
    ...mapGetters(['routePath', 'userPermissions', 'isCollapse', 'userInfo']),
    allHasPermissions() {
      if (!this.userPermissions || !this.userPermissions.length) return []
      const flatMenus = []
      this.navMenus.slice(1).forEach((item) => {
        if (item?.children) {
          flatMenus.push(...item.children.flat(Infinity))
        } else {
          flatMenus.push(item)
        }
      })
      return flatMenus.filter((item) =>
        this.userPermissions.includes(item.permission_name)
      )
    }
  },
  // props:{
  //   navMenus:{
  //     type:Array
  //   }
  // },
  data() {
    return {
      navMenus: [],
      colorArray: ['rgb(31, 218, 202)', 'rgb(191, 12, 44)', 'rgb(63, 178, 127)', 'rgba(77, 175, 27, 0.79)', 'rgb(225, 133, 37)', '#d03050', 'rgb(0, 216, 255)'],
      hasPermissions: [],
      loading: false,
      dialogVisible: false,
      selectData: []
    }
  },
  methods: {
    goToPage(routeName, menu) {
      // console.log(routeName)
      if (menu.type === 'button') {
        this.$utils.jumpToButtonUrl(menu.url)
        return
      }
      this.$utils.jumpPage(this, routeName, menu)
    },
    setColor(k) {
      return this.colorArray[k % this.colorArray.length]
    },
    handleEdit() {
      this.selectData = JSON.parse(JSON.stringify(this.hasPermissions))
      this.dialogVisible = true
    },
    handleStore() {
      if (this.selectData.length > 12) {
        this.$message.error('菜单不得大于12个')
      } else {
        this.hasPermissions = this.selectData
        this.saveData()
        this.dialogVisible = false

      }

    },
    handleSelect(item) {
      const idx = this.selectData.findIndex(o =>
        String(o.permission_name) === String(item.permission_name)
      )
      idx < 0 ? this.selectData.push(item) : this.selectData.splice(idx, 1)
    },
    isIncloud(item) {
      return this.selectData.some(o =>
        String(o.permission_name) === String(item.permission_name)
      )
    },
    async saveData() {
      // localStorage.setItem('lbPreviewRow', JSON.stringify(this.configData))
      const data = {
        type: 'shortcut_nav',
        settings: JSON.stringify(this.hasPermissions)
      }
      await this.$api.saveMySetting(data)
    },
    async getUserSetting() {
      try {
        const data = {
          type: 'shortcut_nav',
          user_id: this.userInfo.id
        }
        const { info } = await this.$api.getMySetting(data)
        const tableSet = info?.settings ? JSON.parse(info.settings) : null
        if (tableSet && tableSet.length) {
          const filtered = tableSet.filter(hp =>
              this.allHasPermissions.some(ahp => String(ahp.permission_name) === String(hp.permission_name))
          )
          this.hasPermissions = filtered.length ? filtered : this.allHasPermissions.slice(0, 12)
        } else {
          this.hasPermissions = this.allHasPermissions.slice(0, 12)
        }
      } catch (e) {
        console.error('getUserSetting 异常:', e)
        this.hasPermissions = this.allHasPermissions.slice(0, 12)
      }
    },
    async fetchMenuTree() {
      try {
        const res = await menuApi.getMenuTree()
        const list = Array.isArray(res) ? res : Object.values(res || {})
        this.navMenus = this.filterActiveMenus(list)
      } catch (e) {
        console.error('获取菜单树失败', e)
      }
    },
    filterActiveMenus(menus) {
      return menus
        .filter(item => String(item.status) === '1')
        .map(item => {
          const filteredChildren = item.children ? this.filterActiveMenus(item.children) : []
          if (item.children && item.children.length > 0 && filteredChildren.length === 0) {
            return null
          }
          return { ...item, children: filteredChildren }
        })
        .filter(Boolean)
    }
  },
  watch: {
    allHasPermissions(val) {
      if (val && val.length && !this.hasPermissions.length) {
        this.getUserSetting()
      }
    }
  },
  mounted() {
    this.fetchMenuTree()
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  padding: 0 !important;
}

::v-deep .el-card__header {
  border-bottom: none;
}

.colClass {
  height: 100px;
  //line-height: 100px;
  //border: 1px solid rgba(0, 0, 0, 0.88);
  box-shadow: 1px 0 0 0 #f0f0f0, 0 1px 0 0 #f0f0f0, 1px 1px 0 0 #f0f0f0, 1px 0 0 0 #f0f0f0 inset, 0 1px 0 0 #f0f0f0 inset;
  text-align: center;
  cursor: pointer;
  position: relative;

  > span {
    display: block;
    margin-top: 10px;
  }

  .svgCol {
    font-size: 30px;
    display: block;
    margin-top: 20px;
  }

  &:hover {
    box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
    transition: 0.2s;
  }
}

.badge {
  position: absolute;
  right: -4px;
  z-index: 99;
}

::v-deep .el-dialog__header {
  padding: 20px !important;
}
</style>
